import { createElement } from 'react';

import { TableColumns } from '../types/tableColumns.types';
import { PdfTable, PdfTableBody, PdfTableHeader } from './components';

type CreateTable<TData> = {
  data: TData[];
  columns: TableColumns<unknown>;
  tableHeader?: React.ReactNode;
  elementClassId: string;
};

const createTableBody = (elementClassId: string) => {
  return createElement(PdfTableBody, { key: 'table-body', tableRowClassId: elementClassId });
};

const createTableHead = <TData,>({
  tableHeader,
  columns,
}: Pick<CreateTable<TData>, 'tableHeader' | 'columns'>) => {
  return createElement(PdfTableHeader, {
    tableHeader,
    columns,
    key: 'table-header',
  });
};

const createTable = <TData,>({
  data,
  columns,
  tableHeader,
  elementClassId,
}: CreateTable<TData>) => {
  return createElement(PdfTable, { data, columns, tableHeader }, [
    createTableHead({ tableHeader, columns }),
    createTableBody(elementClassId),
  ]);
};

const PrintTable = () => {};

/** Creates a printable table  */
PrintTable.create = createTable;

export { PrintTable };
